import { render, staticRenderFns } from "./HoloverzScreen.vue?vue&type=template&id=4826da5c&scoped=true"
import script from "./HoloverzScreen.vue?vue&type=script&lang=js"
export * from "./HoloverzScreen.vue?vue&type=script&lang=js"
import style0 from "./HoloverzScreen.vue?vue&type=style&index=0&id=4826da5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826da5c",
  null
  
)

export default component.exports